import AdminPageLink from "./AdminPageLink"
import AppVersion from "./AppVersion"
import { useTranslation } from "react-i18next";

export default function CopyRight() {
    const copyDate = new Date().getFullYear();
    const { t } = useTranslation();

    return (
        <p className="text-center copy-rights border-0 mb-0">
            {t("rights_reserved")} 2024-{copyDate}
            <AppVersion />
            <AdminPageLink />
        </p>
    );
}